import SearchBar from 'blocks/search-bar';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import type { NextPage, GetStaticProps, GetStaticPaths } from 'next';
import PageService from 'services/PageService/PageService';
import { IGenericPage } from 'types/interfaces';
import { SearchResultsByLocationType, InspirationType } from 'types/types';
import TravelSearchResults from 'blocks/TravelSearchResults/TravelSearchResults';

interface ISearchResults extends IGenericPage {
  searchResults: SearchResultsByLocationType[];
  inspirations: InspirationType[];
  initialSearchValue: string;
}

const GeneralSearchResultsPage: NextPage<ISearchResults> = ({
  globalLayoutProps,
  searchResults,
  inspirations,
  initialSearchValue,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <SearchBar
        inspirations={inspirations}
        initialSearchValue={initialSearchValue}
      />
      <TravelSearchResults searchResults={searchResults} />
    </GlobalLayout>
  );
};

export default GeneralSearchResultsPage;

export const getStaticProps: GetStaticProps = async context => {
  const { idLocation } = context.params as { idLocation: string };

  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.SEARCH_RESULTS + `/${idLocation}`,
  });
  const data = await PageService.getSearchResultsByLocationId(idLocation);
  const inspirations = await PageService.getInspirationsPage();

  const initialSearchValue = data[0]?.location || '';

  return {
    props: {
      ...genericPageProps,
      searchResults: data,
      inspirations: inspirations.inspirations,
      initialSearchValue,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
